<template>
   
<div style="margin: 5px;">
    <InputGroup>
    <InputGroupAddon>{{ label }}</InputGroupAddon>
    <InputText   type="email" 
                 placeholder="E-mail address" 
                 v-model="value" 
                :disabled="disabled" 
                :required="required" />
    <Button icon="pi pi-search" @click="CheckEmail()"  :disabled="disabled || isError"/>
</InputGroup>
</div>

</template>  
<script>

import Service from "../../service/service";
import CommonService from "../../service/CommonService";

export default {
    props: ["modelValue", 'label', 'disabled','required'],
    emits: ["update:modelValue","update:error"],
    name: 'EmailAddress',
    components: {

    },
    data() {
        return {
            value: "",
        }
    },
    Service: null,
    CommonService: null,
    created(){
        this.Service = new Service();
        this.CommonService = new CommonService();
        this.value = this.modelValue;
       /*  if(!this.label){
            this.label='Supervisor Contact';
        } */
       // console.log('MySourcerContact.................')
       // console.log(this.modelValue)
       // console.log(this.value)
    },
    
    mounted(){
        this.value = (this.modelValue);
        this.$emit("update:error", this.isError);
      },
    watch: {
            /* modelValue: function (newVal, oldVal) {
              // watch it
              console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.value = this.modelValue
            }, */
            value: function (newVal) {
              // watch it
              //console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },

        computed:{
             isError(){
                return false;
            } 
        },

    methods: {
       /*  PassEmail() {
            this.$emit('update:modelValue', this.value);
        },*/
        async CheckEmail() {
                let self=this;
                await this.CommonService.CheckEmailExist(this.value).then(async (data) => {

                   if(true==data){
                    self.NotAllowToUse();
                   }
                   else {
                    self.AllowToUse();
                   }

                   // console.log('CheckEmail')
                    //console.log(data)
                    
                })

               
            
        },
        AllowToUse() {
            this.$toast.add({
                severity: 'success', summary: 'Success Message', detail: '此Email 可以使用', life: 3000
            })
            this.redborder = ''
        },
        NotAllowToUse() {
            this.$toast.add({
                severity: 'warn', summary: 'Warn Message', detail: '此Email 已申請過.', life: 3000
            })
            this.redborder = 'p-invalid'
        }, 
        validateEmail() {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) // eslint-disable-line
            {
                this.msg['email'] = 'Please enter a valid email address';
            } else {
                this.msg['email'] = '';
            }
        },
        ValidateEmail(email) {
            console.log(email)
            /* if(email)
            {
                //console.log('ValidateEmail')
                //var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

                var validRegex =/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/;// eslint-disable-line
                //var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;// eslint-disable-line
                if (email.match(validRegex)) {
                    return true;

                } else {
                    return false;
                }
            } */
            return false;
            

}
    }
}
</script>
 
  
  